module.exports = __webpack_public_path__ + "media/images/sp/stores/asakusa/asakusa_sns_02-b910528625a2abafde87136d9094fa68.jpg";